import { Component, OnInit } from '@angular/core';
import {ScrollService} from '../../api/';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(private scrollService: ScrollService) { }

  ngOnInit() {
    this.scrollService.enableScrollIfDisabled();
  }

}



// WEBPACK FOOTER //
// ./src/app/cms/privacy-policy/privacy-policy.component.ts